import React, { Suspense, useState } from "react";
import "./style.scss";
import HeaderLogo from "../../assets/images/logo.png";
import MapImg from "../../assets/images/footer_map.svg";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../helper";

const ContactForm = React.lazy(() => import("../Popups/ContactForm"));

export default function Footer() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);




  return (
    <footer className="footer-container w-100 bg-secondary">
      <div className="container">
        <div className="row">
          <div className="d-flex col-md-6 col-12 col-lg-12 mb-3">
            <img
              src={HeaderLogo}
              style={{ maxWidth: "165px", marginBottom: "10px", height: "56px" }}
              alt="Logo"
            />
          </div>
          <div className="d-flex w-100 gap-5 flex-column flex-md-row">
            <div className="footer-map-col d-flex mb-3 align-items-start ">
              <a
                target="_blank"
                href="https://maps.app.goo.gl/oEsFY3rRbZWeGY1x5"
                className=""
                style={{ maxHeight: "160px" }}
              >
                <img className="w-100" src={MapImg} />
              </a>

              <div className="d-flex flex-column" style={{ maxWidth: "256px" }}>
                <h5 className="mb-md-4 mb-2">Corporate Office</h5>

                <p>
                  Social CoWorking Spaces Community, A UNIT OF B H @ CO, 3rd
                  Floor 305, Site no. 34 35 39 40, Horamavu Main Road,
                  <br /> Above KFC, Outer Ring Road, Bansawadi, Bangalore –
                  560043
                </p>

                <p className="mt-3 ">GST NO - 29ACIPH7450F1ZI</p>

                <a href="mailto:travel@ursmartspoc.com" className="mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M11.8721 12.5869C11.6143 12.5869 11.3506 12.4697 11.0811 12.2354L2.25684 4.4043C2.72559 4.13477 3.2998 4 3.97949 4H19.7734C20.4531 4 21.0244 4.13477 21.4873 4.4043L12.6631 12.2354C12.3994 12.4697 12.1357 12.5869 11.8721 12.5869ZM1.21973 17.9834C1.14941 17.8076 1.09375 17.6143 1.05273 17.4033C1.01758 17.1865 1 16.9434 1 16.6738V6.95312C1 6.66016 1.02051 6.40234 1.06152 6.17969C1.10254 5.95117 1.15527 5.77246 1.21973 5.64355L7.75879 11.4531L1.21973 17.9834ZM3.78613 19.627C3.46973 19.627 3.17969 19.5918 2.91602 19.5215C2.6582 19.457 2.43848 19.3691 2.25684 19.2578L8.98926 12.5342L10.1318 13.5449C10.4131 13.7969 10.6943 13.9844 10.9756 14.1074C11.2627 14.2246 11.5615 14.2832 11.8721 14.2832C12.1826 14.2832 12.4814 14.2246 12.7686 14.1074C13.0557 13.9844 13.3428 13.7969 13.6299 13.5449L14.7637 12.5342L21.4961 19.2578C21.3145 19.3691 21.0918 19.457 20.8281 19.5215C20.5703 19.5918 20.2832 19.627 19.9668 19.627H3.78613ZM22.5332 17.9834L15.9941 11.4531L22.5332 5.64355C22.5918 5.77246 22.6416 5.95117 22.6826 6.17969C22.7295 6.40234 22.7529 6.66016 22.7529 6.95312V16.6738C22.7529 16.9434 22.7324 17.1865 22.6914 17.4033C22.6504 17.6143 22.5977 17.8076 22.5332 17.9834Z"
                      fill="black"
                    />
                  </svg>
                  <span className="ms-2 ">travel@ursmartspoc.com</span>
                </a>

                <a href="tel:+91 9845094478" className="mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M8.64062 16.1729C7.76172 15.2998 6.9707 14.3799 6.26758 13.4131C5.57031 12.4463 5.0166 11.4854 4.60645 10.5303C4.20215 9.56934 4 8.65234 4 7.7793C4 7.20508 4.10254 6.66309 4.30762 6.15332C4.5127 5.64355 4.83789 5.18066 5.2832 4.76465C5.81641 4.25488 6.39062 4 7.00586 4C7.26367 4 7.50684 4.05273 7.73535 4.1582C7.96973 4.26367 8.16895 4.43359 8.33301 4.66797L10.2402 7.34863C10.4043 7.56543 10.5215 7.76758 10.5918 7.95508C10.6621 8.13672 10.6973 8.30664 10.6973 8.46484C10.6973 8.67578 10.6387 8.87793 10.5215 9.07129C10.4102 9.26465 10.2549 9.46387 10.0557 9.66895L9.41406 10.3193C9.32617 10.4131 9.28223 10.5244 9.28223 10.6533C9.28223 10.7236 9.29102 10.791 9.30859 10.8555C9.33203 10.9199 9.35547 10.9756 9.37891 11.0225C9.53125 11.3037 9.79492 11.6641 10.1699 12.1035C10.5449 12.5371 10.9521 12.9766 11.3916 13.4219C11.8311 13.8672 12.2705 14.2773 12.71 14.6523C13.1494 15.0215 13.5098 15.2822 13.791 15.4346C13.8379 15.458 13.8936 15.4814 13.958 15.5049C14.0225 15.5283 14.0898 15.54 14.1602 15.54C14.3008 15.54 14.415 15.4932 14.5029 15.3994L15.1445 14.7578C15.3496 14.5527 15.5488 14.3945 15.7422 14.2832C15.9355 14.1719 16.1348 14.1162 16.3398 14.1162C16.5039 14.1162 16.6768 14.1543 16.8584 14.2305C17.04 14.3008 17.2393 14.4121 17.4561 14.5645L20.1719 16.4893C20.4004 16.6533 20.5645 16.8467 20.6641 17.0693C20.7695 17.292 20.8223 17.5293 20.8223 17.7812C20.8223 18.0801 20.7549 18.3789 20.6201 18.6777C20.4854 18.9766 20.2979 19.2578 20.0576 19.5215C19.6475 19.9785 19.1904 20.3096 18.6865 20.5146C18.1826 20.7256 17.6377 20.8311 17.0518 20.8311C16.1904 20.8311 15.2764 20.626 14.3096 20.2158C13.3428 19.8057 12.373 19.249 11.4004 18.5459C10.4336 17.8428 9.51367 17.0518 8.64062 16.1729Z"
                      fill="black"
                    />
                  </svg>
                  <span className="ms-2 ">+91 9845094478</span>
                </a>
                <a href="tel:+91 9582241179" className="mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M8.64062 16.1729C7.76172 15.2998 6.9707 14.3799 6.26758 13.4131C5.57031 12.4463 5.0166 11.4854 4.60645 10.5303C4.20215 9.56934 4 8.65234 4 7.7793C4 7.20508 4.10254 6.66309 4.30762 6.15332C4.5127 5.64355 4.83789 5.18066 5.2832 4.76465C5.81641 4.25488 6.39062 4 7.00586 4C7.26367 4 7.50684 4.05273 7.73535 4.1582C7.96973 4.26367 8.16895 4.43359 8.33301 4.66797L10.2402 7.34863C10.4043 7.56543 10.5215 7.76758 10.5918 7.95508C10.6621 8.13672 10.6973 8.30664 10.6973 8.46484C10.6973 8.67578 10.6387 8.87793 10.5215 9.07129C10.4102 9.26465 10.2549 9.46387 10.0557 9.66895L9.41406 10.3193C9.32617 10.4131 9.28223 10.5244 9.28223 10.6533C9.28223 10.7236 9.29102 10.791 9.30859 10.8555C9.33203 10.9199 9.35547 10.9756 9.37891 11.0225C9.53125 11.3037 9.79492 11.6641 10.1699 12.1035C10.5449 12.5371 10.9521 12.9766 11.3916 13.4219C11.8311 13.8672 12.2705 14.2773 12.71 14.6523C13.1494 15.0215 13.5098 15.2822 13.791 15.4346C13.8379 15.458 13.8936 15.4814 13.958 15.5049C14.0225 15.5283 14.0898 15.54 14.1602 15.54C14.3008 15.54 14.415 15.4932 14.5029 15.3994L15.1445 14.7578C15.3496 14.5527 15.5488 14.3945 15.7422 14.2832C15.9355 14.1719 16.1348 14.1162 16.3398 14.1162C16.5039 14.1162 16.6768 14.1543 16.8584 14.2305C17.04 14.3008 17.2393 14.4121 17.4561 14.5645L20.1719 16.4893C20.4004 16.6533 20.5645 16.8467 20.6641 17.0693C20.7695 17.292 20.8223 17.5293 20.8223 17.7812C20.8223 18.0801 20.7549 18.3789 20.6201 18.6777C20.4854 18.9766 20.2979 19.2578 20.0576 19.5215C19.6475 19.9785 19.1904 20.3096 18.6865 20.5146C18.1826 20.7256 17.6377 20.8311 17.0518 20.8311C16.1904 20.8311 15.2764 20.626 14.3096 20.2158C13.3428 19.8057 12.373 19.249 11.4004 18.5459C10.4336 17.8428 9.51367 17.0518 8.64062 16.1729Z"
                      fill="black"
                    />
                  </svg>
                  <span className="ms-2 ">+91 9582241179</span>
                </a>
              </div>
            </div>

            <div className="d-flex flex-column col-md-2 col-12 col-lg-2 mb-3 ">
              <h5 className="text-uppercase mb-md-4 mb-2 ">POLICY</h5>
              <Link to={"/terms"} onClick={scrollToTop} className="footer-link mb-2 text-start ">Terms of service</Link>
              <Link to="/privacy-policy" onClick={scrollToTop} className="footer-link mb-2 text-start ">Privacy policy</Link>
              <Link to="/refund-policy" onClick={scrollToTop} className="footer-link mb-2 text-start ">
                Cancellation / Refund policy
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="container d-flex justify-content-between footer-bottom-top gap-3">
          <div className=" d-flex align-items-center footer-social-links">
            <span className="me-4">FOLLOW US</span>
            <a
              href="https://www.facebook.com/share/14zhDoza24/"
              className="text-primary mx-2"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M23.4463 18L24.335 12.2087H18.7782V8.45063C18.7782 6.86625 19.5544 5.32188 22.0432 5.32188H24.5694V0.39125C24.5694 0.39125 22.2769 0 20.085 0C15.5088 0 12.5175 2.77375 12.5175 7.795V12.2087H7.43066V18H12.5175V32H18.7782V18H23.4463Z"
                  fill="currentColor"
                />
              </svg>
            </a>

            <a
              href="https://x.com/UrSmartSpoc?t=JZx_616CcG6Up7yLxTLUUg&s=08"
              target="_blank"
              className="text-primary mx-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M5.87243 4C5.00976 4 4.50409 4.97169 4.99743 5.67969L12.9818 17.0911L4.96618 26.4609C4.44751 27.0663 4.87718 28 5.67451 28H6.55993C6.95059 28 7.32222 27.8286 7.57555 27.5312L14.5599 19.349L19.8177 26.862C20.3177 27.574 21.1333 28 22.0026 28H26.4479C27.3106 28 27.8163 27.0296 27.3229 26.3229L18.8985 14.2656L26.5339 5.32031C26.9766 4.80031 26.6072 4 25.9245 4H24.7969C24.4076 4 24.0372 4.17015 23.7839 4.46615L17.3282 12.013L12.5261 5.14062C12.0274 4.42596 11.2132 4 10.3412 4H5.87243Z"
                  fill="currentColor"
                />
              </svg>
            </a>

            <a
              target="_blank"
              href="https://api.whatsapp.com/send/?phone=919148069148&text=Hi&type=phone_number&app_absent=0"
              className="text-primary mx-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.9208 6.06902C23.2886 3.44636 19.788 2.00156 16.0586 2C8.37408 2 2.12004 8.22378 2.11692 15.8737C2.11598 18.319 2.75776 20.7059 3.97787 22.8102L2 30L9.39068 28.0705C11.427 29.1759 13.7197 29.7586 16.053 29.7592H16.0586C16.0583 29.7592 16.0589 29.7592 16.0586 29.7592C23.7422 29.7592 29.9969 23.5348 30 15.8846C30.0016 12.1774 28.5529 8.69169 25.9208 6.06902ZM10.397 16.3786C10.2228 16.1472 8.9746 14.4989 8.9746 12.7924C8.9746 11.086 9.8746 10.2472 10.1938 9.90036C10.5129 9.55347 10.8906 9.46667 11.1228 9.46667C11.3551 9.46667 11.5877 9.46884 11.7906 9.4788C12.0044 9.48969 12.2917 9.39791 12.5743 10.074C12.8647 10.768 13.5612 12.4748 13.6484 12.6481C13.7356 12.8217 13.7935 13.0239 13.6775 13.2554C13.5615 13.4865 13.5034 13.6312 13.3292 13.8337C13.1551 14.0363 12.9635 14.2858 12.8066 14.441C12.6321 14.614 12.4505 14.8016 12.6537 15.1485C12.8569 15.4957 13.5559 16.6309 14.5915 17.5503C15.922 18.7316 17.0446 19.0974 17.3928 19.271C17.7411 19.4446 17.9443 19.4157 18.1475 19.1842C18.3507 18.9528 19.0184 18.1719 19.2507 17.825C19.4829 17.4781 19.7152 17.536 20.0344 17.6514C20.3538 17.7671 22.0663 18.6059 22.4146 18.7792C22.7628 18.9528 22.9951 19.0396 23.0823 19.1842C23.1695 19.3289 23.1695 20.023 22.8791 20.8328C22.5887 21.6426 21.197 22.3818 20.5277 22.4811C19.9275 22.5704 19.1681 22.6077 18.3335 22.3436C17.8277 22.184 17.1787 21.9705 16.3475 21.6134C12.8534 20.1116 10.5714 16.6101 10.397 16.3786Z"
                  fill="currentColor"
                />
              </svg>
            </a>

            <a
              href="https://www.linkedin.com/in/ursmartspoc-co-b8b5b8129?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
              target="_blank"
              className="text-primary mx-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M28 2H3.99375C2.89375 2 2 2.90625 2 4.01875V27.9813C2 29.0938 2.89375 30 3.99375 30H28C29.1 30 30 29.0938 30 27.9813V4.01875C30 2.90625 29.1 2 28 2ZM10.4625 26H6.3125V12.6375H10.4688V26H10.4625ZM8.3875 10.8125C7.05625 10.8125 5.98125 9.73125 5.98125 8.40625C5.98125 7.08125 7.05625 6 8.3875 6C9.7125 6 10.7937 7.08125 10.7937 8.40625C10.7937 9.7375 9.71875 10.8125 8.3875 10.8125ZM26.0187 26H21.8687V19.5C21.8687 17.95 21.8375 15.9563 19.7125 15.9563C17.55 15.9563 17.2188 17.6438 17.2188 19.3875V26H13.0688V12.6375H17.05V14.4625H17.1062C17.6625 13.4125 19.0188 12.3062 21.0375 12.3062C25.2375 12.3062 26.0187 15.075 26.0187 18.675V26Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
          <button
            onClick={() => setIsContactFormOpen(true)}
            className="want-to-reach-btn"
          >
            WANT US TO REACH OUT
          </button>
        </div>
      </div>

      <div className="footer-bottom bg d-flex justify-content-center">
        <p className="text-uppercase">
          © 2025 URSMARTSPOC. All Rights Reserved
        </p>
      </div>

      {isContactFormOpen && (
        <Suspense fallback={<div className="loader"></div>}>
          <ContactForm onClose={() => setIsContactFormOpen(false)} />
        </Suspense>
      )}
    </footer>
  );
}
